export { fetchFile as parse, fetchFileAsync as parseAsync } from '../../util/';